import { render, staticRenderFns } from "./SortDefinitionNested.vue?vue&type=template&id=3c3df033&scoped=true"
import script from "./SortDefinitionNested.vue?vue&type=script&lang=js"
export * from "./SortDefinitionNested.vue?vue&type=script&lang=js"
import style0 from "./SortDefinitionNested.vue?vue&type=style&index=0&id=3c3df033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3df033",
  null
  
)

export default component.exports